/**
 * @generated SignedSource<<b10e741399880c87abfb9bde6d9699ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_item$data = {
  readonly displayPrice?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"PriceDisplayVariant_displayPrice">;
  } | null> | null;
  readonly firstPhotoWebPath: string | null;
  readonly internalBuyLinks?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_links">;
  } | null> | null;
  readonly isAuctionEnabled: boolean | null;
  readonly itemIsOnHold: boolean | null;
  readonly seller?: {
    readonly isAccessible: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_seller">;
  } | null;
  readonly skus: ReadonlyArray<{
    readonly displayPrice?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PriceDisplayVariant_displayPrice">;
    } | null> | null;
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_sku" | "PriceDisplay_sku">;
  } | null> | null;
  readonly storyTellingModule: {
    readonly tabs: ReadonlyArray<{
      readonly supplementaryEditorial: {
        readonly articles: ReadonlyArray<{
          readonly __typename: "WordpressArticleType";
        }> | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespBreadcrumbs_item" | "PdpRespDetailTabs_item" | "PdpRespIconBubblesWrapper_item" | "PdpRespPricingGuidanceInfo_item" | "PdpRespSharedHeroCarousel_item" | "PdpRespSharedPrintDetailsLazy_item" | "PdpRespSidebarBlurbs_item" | "PdpRespSidebarButtons_item" | "PdpRespSidebarPillsLazy_item" | "PdpRespSidebarSellerInfoAndContactLazy_item" | "PdpRespSimilarItemsLanding_item" | "PdpRespSwatchSelector_item" | "PdpRespTitle_item" | "PdpSharedAuctionCountdownLazy_item" | "PdpSharedAuctionInfo_item" | "PdpSharedEditorialArticles_item" | "PdpSharedEstimatedValue_item" | "PdpSharedFramingStatus_item" | "PdpSharedQuantitySelect_item" | "PdpSharedSellerItemsCarousel_item" | "PdpSharedSidebarFavorites_item" | "PdpSharedVisuallySimilarItemsCarouselLazy_item" | "PdpSharedYMALItemsCarousel_item" | "PriceDisplayVariant_item" | "PriceDisplay_item" | "SharedRespLinksBlock_item" | "usePdpPricingOptimizationVariant_item" | "usePdpRecentHistoryTracker_item">;
  readonly " $fragmentType": "PdpRespContainer_item";
};
export type PdpRespContainer_item$key = {
  readonly " $data"?: PdpRespContainer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v1 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v2 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v3 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v4 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v5 = {
  "alias": null,
  "args": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PriceDisplayVariant_displayPrice"
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "afterDisplayOrBuaSsr"
    },
    {
      "kind": "RootArgument",
      "name": "fetchAuctionOrBuaSsr"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": "itemIsOnHold",
      "args": [
        (v0/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "isOnHold",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpPricingOptimizationVariant_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedEditorialArticles_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespBreadcrumbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTitle_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarPillsLazy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedYMALItemsCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedVisuallySimilarItemsCarouselLazy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerItemsCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedQuantitySelect_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpRecentHistoryTracker_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_item"
    },
    {
      "condition": "afterDisplayOrBuaSsr",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "kind": "FragmentSpread",
          "name": "PriceDisplay_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PriceDisplayVariant_item"
        },
        (v5/*: any*/)
      ]
    },
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_item"
        }
      ]
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFramingStatus_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetailTabs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetailsLazy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSidebarFavorites_item"
    },
    {
      "condition": "fetchAuctionOrBuaSsr",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedAuctionInfo_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionCountdownLazy_item"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccessible",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSidebarSellerInfoAndContactLazy_seller"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedHeroCarousel_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespIconBubblesWrapper_item"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalBuyLinkType",
          "kind": "LinkedField",
          "name": "internalBuyLinks",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedRespLinksBlock_links"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfoAndContactLazy_item"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedEstimatedValue_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPricingGuidanceInfo_item"
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "condition": "isMultiSku",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "hasSkuId",
                  "value": true
                },
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "PriceDisplay_sku"
            },
            (v5/*: any*/)
          ]
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarBlurbs_sku"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WordpressArticlesType",
              "kind": "LinkedField",
              "name": "supplementaryEditorial",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WordpressArticleType",
                  "kind": "LinkedField",
                  "name": "articles",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "8939ff69b50e02f75aa6b28f363a5d02";

export default node;
